import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, Subscription } from 'rxjs';
import { AccordionComponent } from '../../../../shared/components/accordion/accordion.component';
import { ButtonComponent } from '../../../../shared/components/button/button.component';
import { MultiselectDropdownComponent } from '../../../../shared/components/multiselect-dropdown/multiselect-dropdown.component';
import { DEFAULT_BLOG_FILTER } from '../../../../shared/constants/constants';
import { BlogFilter } from '../../../../shared/interface/interface';
import { Blog } from '../../../../shared/models/blog.model';
import {
  DropDownConfig,
  DropDownOption,
} from '../../../../shared/models/multiselect-dropdown.model';
import { BlogsService } from '../../../../shared/services/blogs.service';
import { SharedModule } from '../../../../shared/shared.module';

@Component({
  selector: 'app-blog-links',
  standalone: true,
  imports: [
    MultiselectDropdownComponent,
    SharedModule,
    AccordionComponent,
    ButtonComponent,
  ],
  templateUrl: './blog-links.component.html',
  styleUrl: './blog-links.component.scss',
})
export class BlogLinksComponent implements OnInit {
  @Input() form!: FormGroup;
  @Input() blogId: string | null = null;
  isLoading = false;
  dropDownConfig: DropDownConfig = {
    allowSearchFilter: true,
    placeholder: 'Select Link',
  };
  subscription: Subscription = new Subscription();
  blogList: Blog[] = [];
  totalBlog: number = 0;
  private blogFilterSubject$: BehaviorSubject<BlogFilter> =
    new BehaviorSubject<BlogFilter>(DEFAULT_BLOG_FILTER);
  blogFilter = this.blogFilterSubject$.asObservable();

  constructor(
    private fb: FormBuilder,
    private toastr: ToastrService,
    private blogsService: BlogsService
  ) {}
  ngOnInit(): void {
    const sub = this.blogFilterSubject$.subscribe((value: BlogFilter) => {
      this.getBlogList(value);
    });
  }
  getBlogList(value: BlogFilter) {
    this.isLoading = true;
    this.blogsService.getBlogList(value).subscribe({
      next: (res: any) => {
        this.blogList =
          value.pageNumber > 1 ? [...this.blogList, ...res.result] : res.result;
        this.totalBlog = res.count;
        this.isLoading = false;
      },
      error: (err: any) => {
        console.error(err);
        this.toastr.error(
          err?.error?.message || err?.message || 'Something went wrong!'
        );
        this.isLoading = false;
      },
    });
  }

  loadMoreIfLastIndex() {
    this.updateBlogsFilter({
      ...this.blogFilterSubject$.value,
      pageNumber: this.blogFilterSubject$.value.pageNumber + 1,
    });
  }
  handleSearch(searchText: string) {
    if (searchText.length === 0 || searchText?.trim()) {
      this.updateBlogsFilter({
        ...this.blogFilterSubject$.value,
        pageNumber: 1,
        searchText: searchText,
      });
    }
  }
  removeLink(id: any) {
    const links = this.form.get('relativeBlogIds')?.value || [];
    const updatedLinks = links.filter((el: any) => el.value !== id);
    this.form.get('relativeBlogIds')?.patchValue(updatedLinks);
  }
  updateBlogsFilter(filter: BlogFilter) {
    this.blogFilterSubject$.next(filter);
  }
  get blogOptions(): DropDownOption[] {
    return (
      this.blogList.filter((blog)=> this.blogId !== blog.id).map((blog) => ({ value: blog.id, label: blog.title, isDisabled: blog?.id === this.blogId })) || []
    );
  }
}
